/**
 * V2 Featured lists — /lists/featured (2026-08-04 founder ask).
 *
 * The admin-curated shelf: public lists worth borrowing, starred from
 * the admin Lists tab (lists.featured, 20260804b migration). Reached
 * from Discover's door; open to everyone including signed-out visitors
 * — a featured list is exactly the kind of page worth sharing around.
 */
import { escapeHtml } from '../../../assets/js/utils.js';
import { icon } from '../../ui/icons.js';
import { fetchFeaturedLists } from './lists.js';

export function mount(el, ctx) {
  const { router } = ctx;
  const basePath = window.YOINK_CONFIG?.basePath || '/adventure';
  let destroyed = false;

  function row(list) {
    const who = list.owner.full_name || list.owner.username;
    return `
      <button type="button" class="mylist-row" data-open-featured-list
        data-owner="${escapeHtml(list.owner.username)}" data-slug="${escapeHtml(list.slug)}">
        ${icon('bookmark', 20)}
        <span class="mylist-body">
          <span class="mylist-title"><span class="featured-star" aria-hidden="true">★</span> ${escapeHtml(list.title)}</span>
          <span class="mylist-meta">by ${escapeHtml(who)} · ${list.entry_count} place${list.entry_count === 1 ? '' : 's'}</span>
          ${list.description ? `<span class="mylist-meta">${escapeHtml(list.description)}</span>` : ''}
        </span>
      </button>`;
  }

  function render(lists) {
    el.innerHTML = `
      <nav class="v2-back" aria-label="Back"><a href="${basePath}/" data-route="discover">← Discover</a></nav>
      <section class="v2-mylists" aria-label="Featured lists">
        <h2 class="v2-page-title">Featured lists</h2>
        <p>Lists worth borrowing — picked from the journal by the rangers.</p>
        <div class="mylist-rows">
          ${lists.length ? lists.map(row).join('')
            : '<p class="v2-empty">Nothing on the shelf just yet — check back soon.</p>'}
        </div>
      </section>`;
  }

  function onClick(event) {
    const rowEl = event.target.closest('[data-open-featured-list]');
    if (rowEl) {
      router.navigate('list', { username: rowEl.dataset.owner, slug: rowEl.dataset.slug });
      return;
    }
    const backLink = event.target.closest('a[data-route]');
    if (backLink) {
      event.preventDefault();
      router.navigate(backLink.dataset.route);
    }
  }

  el.addEventListener('click', onClick);
  el.innerHTML = '<div class="v2-loading">Unrolling the map…</div>';
  fetchFeaturedLists().then((lists) => {
    if (!destroyed) render(lists);
  });

  return () => {
    destroyed = true;
    el.removeEventListener('click', onClick);
  };
}
